<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { getSiteConfig } from './api'
export default {
  name: 'App',
  // 启动时拉取全局站点配置（含地图 Key/安全密钥），存入 store 供各页面复用
  created() {
    getSiteConfig().then(res => {
      if (res.data && res.data.code === 200 && res.data.data) {
        this.$store.commit('SET_CONFIG', res.data.data)
      }
    }).catch(() => {})
  }
}
</script>
<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body, #app { height: 100%; }
body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif; color: #333; line-height: 1.6; background: #fff; }
a { text-decoration: none; color: inherit; }
.container { max-width: 1500px; margin: 0 auto; padding: 0 20px; }
</style>
